export type WriteMethodTypeValue = "0" | "1" | "2" | "3" | "4";

export class WriteMethodTypes {
  /**
   * 指定なし：0
   */
  public static Default: WriteMethodTypeValue = "0";
  
  /**
   * 直接記載のみ（確認ダイアログあり）：1
   */
  public static DirectWithConfirmDialog: WriteMethodTypeValue = "1";

  /**
   * WFのみ（確認ダイアログあり）：2
   */
  public static WorkflowWithConfirmDialog: WriteMethodTypeValue = "2";

  /**
   * 直接記載のみ（警告）：3
   */
  public static DirectOnly: WriteMethodTypeValue = "3";

  /**
   * WFのみ（警告）：4
   */
  public static WorkflowOnly: WriteMethodTypeValue = "4";

  public static get DirectDefaultTargets(): WriteMethodTypeValue[] {
    return [WriteMethodTypes.Default, WriteMethodTypes.DirectWithConfirmDialog, WriteMethodTypes.DirectOnly];
  }

  public static get WorkflowDefaultTargets(): WriteMethodTypeValue[] {
    return [WriteMethodTypes.Default, WriteMethodTypes.WorkflowWithConfirmDialog, WriteMethodTypes.WorkflowOnly];
  }
}
